
import { mapMutations, mapGetters } from 'vuex'
import productData from '@/data/products.json'

export default {
  name: 'AddedToCartModal',
  props: {
    // kept so the footer can hide the promo line if ever needed; defaults to showing it
    hidepromo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      added: 'cart/showAdded', // { show, id, message, error }
      cartLoading: 'cart/getLoading',
      regionClicked: 'cart/getRegionClicked',
    }),
    // open on a successful add or an error
    isOpen() {
      return this.added.show || this.added.error
    },
    error() {
      return this.added.error
    },
    message() {
      return this.added.message
    },
    // resolve the product from the id the store recorded on add
    product() {
      const id = this.added.id
      if (id === null || id === undefined) return {}
      const found = productData.find((o) => o.id.toString() === id.toString())
      return found || {}
    },
    // price comes from the same filter the buttons use, computed live off current region
    price() {
      // guard against SSR / pre-add state where prices aren't ready
      if (!this.product || !this.product.id || !this.product.prices) {
        return { saleType: 'none', offerCode: '', pricesDiscounted: [] }
      }
      return this.$options.filters.priceData(this.product)
    }
  },
  watch: {
    cartLoading(newVal) {
      this.isLoading = newVal
    },
  },
  methods: {
    ...mapMutations({
      hide: 'cart/hideAdded',
    }),
  },
}
